import Image from 'app/Components/Shared/Image/image';
import React, { useEffect,useState } from 'react';
import { connect } from 'react-redux';
import { setPhoneNumberForCallBack } from '../../ServiceAppointmentBlockSlice';
import {doCallBack} from '../../ServiceAppointmentAsyncthunk';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../../Shared/TextInput/TextInput';
import callServiceIcon from '../../images/call-service-icon.svg';

const NumberToReturnPage = (props) => {
const [errorDescription, setErrorDescription] = useState('');
const [contactNumber, setContactNumber] = useState(props.contactNumber);
const [displayCreateOrderError , setDisplayCreateOrderError] = useState(false);

    useEffect  (() => {
        setDisplayCreateOrderError(false);
    },[]);

    useEffect  (() => {
        if (props.contactNumber.length === 10) {
            const contactNumberFormat = props.contactNumber.slice(0, 3) + '-' + props.contactNumber.slice(3);
            setContactNumber(contactNumberFormat);
        }
    }, [props.contactNumber]);

    const handleOnContinue = async ()=>{
        const phonePattern = /^0((5\d{1})|([2-4,8-9]\d{0,1}))-?\d{7}$/;

        if (!phonePattern.test(contactNumber) || contactNumber.length < 9) {
            setErrorDescription('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
        } else {
            props.setPhoneNumberForCallBack(contactNumber);
            const response = await props.doCallBack();
            if(!response?.payload?.IsSuccess){
                setDisplayCreateOrderError(true);
            }
        }
    };

    function changePhoneInputHandler(value){
        setErrorDescription('');
        setContactNumber(value);
    }

  return (
      <div className='number-to-return-page page-wrapper'>
        <div className='content'>
            <Image src={callServiceIcon} alt='call service icon' />
            <h1>לאיזה מספר לחזור?</h1>
            <h2>{props.subTitle}</h2>
            <TextInput
                className='otp-user-input'
                //  ref={ref}
                name='contactNumber'
                type='text'
                pattern='[0-9]*'
                id='contactNumber'
                maxLength='10'
                autoComplete='off'
                placeholder={'מספר טלפון'}
                required='required'
                value={contactNumber}
                error={errorDescription}
                onChange={(e) => changePhoneInputHandler(e.target.value)}
                ></TextInput>
        </div>
        <div className='button-wrapper'>
            {displayCreateOrderError && <span className='work-order-error'>השליחה נכשלה, אנא נסו שוב</span>}
            <BtnSubmit
                className='btn-submit-purple'
                isBusiness={false}
                text={'תחזרו אלי'}
                onclick={()=>handleOnContinue()}
                formid='error-page'
                isDisplayArrows={false}
            />
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    contactNumber : state.authentication?.loginData?.userDetails?.contactNumber,
    subTitle:  state.serviceAppointmentSchedulerBlock.dataEpi.subInfo
  };
};

const mapDispatchToProps = { setPhoneNumberForCallBack , doCallBack };

export default connect(mapStateToProps, mapDispatchToProps)(NumberToReturnPage);
